// extracted by mini-css-extract-plugin
export default {"demoVideo":"videoModal_demoVideo__AEpUI","videoContainer":"videoModal_videoContainer__9eTly","video":"videoModal_video__izDKL"};